import React from 'react';
import { motion } from 'framer-motion';
import { analyzeColor } from '../utils/colorLogic';

const MoodPanel = ({ color }) => {
  const { mood } = analyzeColor(color);

  return (
    <motion.div
      key={color}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-xl sm:rounded-2xl md:rounded-3xl h-full"
    >
      <div
        className="absolute inset-0 opacity-20 blur-[80px] sm:blur-[100px] transition-colors duration-1000 scale-125"
        style={{ backgroundColor: color }}
      />

      <div className="glass-panel relative z-10 p-6 sm:p-8 md:p-10 lg:p-12 overflow-hidden border-white/[0.08] h-full flex flex-col justify-between min-h-[400px] sm:min-h-[500px]">
        <div className="space-y-4 sm:space-y-6 md:space-y-8">
          <div className="flex items-center gap-3 sm:gap-4">
            <span className="h-0.5 sm:h-1 w-12 sm:w-16 md:w-20 bg-blue-500 rounded-full" />
            <h3 className="text-[10px] sm:text-xs md:text-sm font-light text-blue-400 uppercase tracking-[0.15em] sm:tracking-[0.2em] font-display">
              Color Intelligence
            </h3>
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-extralight text-white tracking-[-0.04em] leading-[0.9] uppercase break-words font-display">
            {mood.title}
          </h2>

          <div className="flex flex-wrap gap-2 sm:gap-3">
            {mood.tags.map(tag => (
              <span
                key={tag}
                className="px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 bg-white/[0.05] rounded-full text-[9px] sm:text-[10px] md:text-xs font-light text-white/95 uppercase tracking-[0.08em] sm:tracking-[0.1em] border border-white/15 font-display shadow-lg"
              >
                {tag}
              </span>
            ))}
          </div>

          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/40 leading-[1.4] sm:leading-[1.35] font-light max-w-3xl font-body">
            {mood.description}
          </p>

          {mood.warning && (
            <div className="p-4 sm:p-5 bg-red-500/10 border-l-4 border-red-500 rounded-lg sm:rounded-xl">
              <p className="text-xs sm:text-sm md:text-base text-red-200 font-medium leading-relaxed">
                {mood.warning}
              </p>
            </div>
          )}
        </div>

        <div className="mt-6 sm:mt-8">
          <div className="p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-black/30 border border-white/[0.05] shadow-2xl">
            <span className="text-[10px] sm:text-xs text-blue-300/30 uppercase font-light tracking-[0.12em] sm:tracking-[0.15em] block mb-4 sm:mb-5 font-display">
              Industry Fit
            </span>
            <div className="space-y-3 sm:space-y-4">
              {mood.industries.map(industry => (
                <div key={industry} className="flex items-center gap-3 sm:gap-4">
                  <div
                    className="w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full shadow-[0_0_15px_rgba(255,255,255,0.4)] flex-shrink-0"
                    style={{ backgroundColor: color }}
                  />
                  <span className="text-xs sm:text-sm md:text-base font-light text-white/60 uppercase tracking-tight font-display">
                    {industry}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MoodPanel;